import { HomeworkType } from './NewHomework.interfaces';
import { SelectTeamsAssignmentWithResources } from './NewHomeworkDialog.interfaces';

export const determineHomeworkType = (
  editModel: SelectTeamsAssignmentWithResources | undefined,
): HomeworkType => {
  let homeworkType = HomeworkType.NotSelected;
  if (editModel) {
    if (editModel?.assignmentId !== '') {
      homeworkType = HomeworkType.AsTeamsAssignment;
    } else {
      homeworkType = HomeworkType.Common;
    }
  }
  return homeworkType;
};

export const getHourStringFromMinutes = (inputMinutes: number): string => {
  const hours = Math.floor(inputMinutes / 60);
  const minutes = inputMinutes - hours * 60;
  return `${padTime(hours)}:${padTime(minutes)}:00`;
};
const padTime = (time: number) => time.toString().padStart(2, '0');

export const getMinutesFromHourString = (hourString: string): string => {
  const hourStringComponents = hourString.split(':');
  let minutes: string;
  if (hourStringComponents.length === 2 || hourStringComponents.length === 3) {
    minutes = (
      Number.parseInt(hourStringComponents[0]) * 60 +
      Number.parseInt(hourStringComponents[1])
    ).toString();
  } else {
    throw new Error(
      `Form of hourstring ${hourString} is not compatible to 'HH:mm:ss' or 'HH:mm'`,
    );
  }
  return minutes;
};

export const parseMinutesStringToNumberIfNecessary = (
  minutes: string,
): number => {
  const regex = /^\d{2}:\d{2}(:\d{2})?$/;
  return regex.test(minutes) ? +getMinutesFromHourString(minutes) : +minutes;
};
